import styled from 'styled-components';

// Hovered category background from the Figma hover state (green at 10%, node 843-21200).
const CATEGORY_ROW_HOVER_BACKGROUND = 'rgba(2, 223, 127, 0.1)';

export const CategoryRow = styled.div`
  width: 100%;
  height: 40px;
  padding: 0 24px;

  display: flex;
  align-items: center;
  column-gap: 12px;

  cursor: pointer;
  background-color: ${({ theme }) => theme.colors.greys.lighter};

  .category-chevron-hover {
    display: none;
  }

  &:hover {
    background-color: ${CATEGORY_ROW_HOVER_BACKGROUND};

    .category-chevron-default {
      display: none;
    }

    .category-chevron-hover {
      display: block;
    }
  }
`;

export const CategoryChevron = styled.img`
  width: 16px;
  height: 16px;
`;
